import {Component, OnInit} from '@angular/core';
import {CampaignTypeConfigObjectBaseComponent} from '../campaign-type-config-object-base.component';
import {ActivatedRoute} from '@angular/router';
import {ConfirmationService} from 'primeng/api';
import {MvsCoreService} from '../../../../../../../../core/shared/service/mvs-core.service';
import {MvsMessageService} from '../../../../../../../../core/shared/service/message/mvs-message.service';
import {ObserverService} from '../../../../../../../../core/shared/object/service/observer.service';

@Component({
    selector: 'campaign-type-config-object-component-side',
    templateUrl: './campaign-type-config-object-side.component.html',
    styleUrls: ['./campaign-type-config-object-side.component.scss'],
    standalone: false
})
export class CampaignTypeConfigObjectSideComponent extends CampaignTypeConfigObjectBaseComponent implements OnInit {

    constructor(
        protected route: ActivatedRoute,
        protected coreService: MvsCoreService,
        protected messageService: MvsMessageService,
        protected confirmationService: ConfirmationService,
        protected observerService: ObserverService
    ) {
        super(route, coreService, messageService, confirmationService, observerService);
    }

    ngOnInit() {
        super.ngOnInit();
    }

    loadSideBarMenuItems() {
        this.navigationItems = [
            {
                label: 'ct.CampaignTypeConfig',
                action: 'ct.CampaignTypeConfig',
                icon: 'fa-regular fa-cog text-xl',
                tooltip: 'Allgemein',
                toggleable: false,
                default: true
            },
            {
                label: 'ct.CampaignMemberStatusType',
                action: 'ct.CampaignMemberStatusType',
                icon: 'fa-regular fa-flag text-xl',
                tooltip: 'Mitgliedstatus-Typen',
                toggleable: false,
                default: false
            },
            {
                label: 'ct.CampaignTemplate',
                action: 'ct.CampaignTemplate',
                icon: 'fa-regular fa-file-lines text-xl',
                tooltip: 'Kampagnenvorlagen',
                toggleable: false,
                default: false
            }
        ];
    }
}
